import ApiService from "@/common/api.service";
import { API_PATH } from "@/common/constant";

export const GET_MEMBERS_BY_HEAD = (params) =>
  ApiService.query(API_PATH.GET_MEMBERS_BY_HEAD, { ...params });

export const GET_PROFILE = (params, setLoading = true) =>
  ApiService.query(API_PATH.GET_PROFILE, { ...params }, setLoading);

export const GET_TARGET_OF_MEMBER = (params) =>
  ApiService.query(API_PATH.GET_TARGET_OF_MEMBER, {
    ...params,
  });
export const GET_ACTION_REVIEWS = (params) =>
  ApiService.query(API_PATH.GET_ACTION_REVIEWS, {
    ...params,
  });

export const SAVE_PERSONAL_GOAL = (params) =>
  ApiService.post(API_PATH.SAVE_PERSONAL_GOAL, {
    ...params,
  });

export const SAVE_ACCOMPLISHMENT = (params) =>
  ApiService.post(API_PATH.SAVE_ACCOMPLISHMENT, {
    ...params,
  });

export const PROCESS_TARGET_SUB = (params) =>
  ApiService.post(API_PATH.PROCESS_TARGET_SUB, {
    ...params,
  });

export const PROCESS_TARGET_SUBMIT = (params) =>
  ApiService.query(API_PATH.PROCESS_TARGET_SUBMIT, { ...params });

export const PROCESS_TARGET_DELETE = (params) =>
  ApiService.post(API_PATH.PROCESS_TARGET_DELETE, { ...params });

export const PROCESS_TARGET_APPROVE = (params) =>
  ApiService.query(API_PATH.PROCESS_TARGET_APPROVE, { ...params });

export const PROCESS_TARGET_REJECT = (params) =>
  ApiService.query(API_PATH.PROCESS_TARGET_REJECT, { ...params });

export const TARGET_API_COMMENT = (params) =>
  ApiService.post(API_PATH.TARGET_API_COMMENT, { ...params });

export const GET_MEMBER_PROFILE_BY_ID = (params) =>
  ApiService.query(API_PATH.GET_MEMBER_PROFILE_BY_ID, { ...params });

export const GET_PARENTS_OF_MEMBER = (params) =>
  ApiService.query(API_PATH.GET_PARENTS_OF_MEMBER, { ...params });

export const GET_ALL_TRANSFER_MEMBERS = (params) =>
  ApiService.query(API_PATH.GET_ALL_TRANSFER_MEMBERS, { ...params });

export const CONFIG_CP_TABLE_MEMBER = (params) =>
  ApiService.put(API_PATH.CONFIG_CP_TABLE_MEMBER, { ...params });

export const PROCESS_TARGET_ACCOMPLISHED = (ptSubId) =>
  ApiService.query(API_PATH.PROCESS_TARGET_ACCOMPLISHED, { ...ptSubId });

export const GET_MEMBER_POSITIONS_API = () =>
  ApiService.get(API_PATH.GET_POSITIONS);

export const GET_MEMBER_TARGETS_HISTORY_API = (params) =>
  ApiService.query(API_PATH.GET_TARGETS_HISTORY, { ...params });

export const EXPORT_COMMITMENT_API = (params) =>
  ApiService.getBuffer(API_PATH.EXPORT_COMMITMENT, { ...params });

export const EXPORT_CSV_API = (params) =>
  ApiService.getBuffer(API_PATH.EXPORT_CSV, { ...params });

export const GET_MEMBER_TARGETS_FILE_API = (params) =>
  ApiService.query(API_PATH.MEMBER_TARGET_FILES, { ...params });

export const GET_MEMBER_TARGET_FILE_PRE_SIGN_URL_API = (params) =>
  ApiService.query(API_PATH.UPLOAD_MEMBER_TARGET_FILES, { ...params });

export const DOWNLOAD_MEMBER_TARGET_FILES_API = (params) =>
  ApiService.query(API_PATH.DOWNLOAD_MEMBER_TARGET_FILES, { ...params });

export const DELETE_MEMBER_TARGET_FILES_API = (fileName) =>
  ApiService.delete(API_PATH.DELETE_MEMBER_TARGET_FILES + `/${fileName}`, {});

export const MEMBER_TARGET_CHANGE_GRADE = (params) =>
  ApiService.post(API_PATH.MEMBER_TARGET_CHANGE_GRADE, {
    ...params,
  });
